import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import EditIcon from 'transfix-icons/build/EditIcon'
import { Card } from 'transfix-ui/components/Card'
import { IconButton } from 'transfix-ui/components/IconButton'
import { ICarrierState, ICarrierReference, ICarrierReferencesState } from 'types/carrier'
import { showReferencesDialog, getCarrierReferences } from 'utils/actions/carrier'
import { IStore } from 'apps/carrier/utils/reducers'
import Reference from './Reference'
import ReferencesDialog from './ReferencesDialog'

interface ISelector {
  carrier: ICarrierState
  carrierReferences: ICarrierReferencesState
}

export const References = () => {
  const dispatch = useDispatch()
  const {
    carrier: { carrierDetails },
    carrierReferences: { references },
  } = useSelector<IStore, ISelector>(({ carrier, carrierReferences }) => ({
    carrier,
    carrierReferences,
  }))
  const showDialog = () => {
    dispatch(showReferencesDialog())
  }
  useEffect(() => {
    if (carrierDetails?.id) dispatch(getCarrierReferences(carrierDetails?.id))
  }, [carrierDetails?.id])
  return (
    <Card>
      <div className='row no-gutter pv4'>
        <h3 className='fl mb0 mt2'>References</h3>
        <div className='fr'>
          <IconButton
            Icon={EditIcon}
            color='tertiary'
            onClick={showDialog}
            data-test='edit-references'
            label='Edit'
            size='large'
          />
        </div>
      </div>
      {references.length === 0 && (
        <div className='text-secondary'>Minimum 3 references are required.</div>
      )}
      {references.map((reference: ICarrierReference, idx: number) => (
        <Reference reference={reference} index={idx} key={reference.id || reference.uuid} />
      ))}
      <ReferencesDialog />
    </Card>
  )
}
